import { ListProductVariationData } from "src/data/product-list/types"
import { formatPriceShort } from "src/utilities/price"

export type NpProductPriceProps = {
  product: {
    price: number
    regularPrice?: number
    variations?: ListProductVariationData[]
  }
}

export const NpProductPrice = ({ product }: NpProductPriceProps) => {
  return (
    <div className="font-product flex items-center gap-2 text-lg">
      <div className="flex items-center gap-1">
        {product.variations && product.variations.length > 1 && <span>Ab</span>}
        {product.price && <span>{formatPriceShort(product.price)}</span>}
      </div>
      {product.regularPrice && (
        <span className="font-normal line-through opacity-50">{formatPriceShort(product.regularPrice)}</span>
      )}
    </div>
  )
}
